var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"height":_vm.height,"width":_vm.width,"src":_vm.imgSrc,"contain":_vm.contain,"max-height":_vm.maxHeight,"max-width":_vm.maxWidth}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }